import { isNull, get } from "lodash"
import locales from "./../../../content.json";

import cross from './img/cross.png'
import laugh from './img/laugh.png'
import relivedFace from './img/relieved-face.png'
import starsEyes from './img/stars-eyes.png'

export const checkIsValidCurrentActivity = data => {
    return validateCurrentStep(get(data, ["lifeChange", "value"], "")) && !data.lifeChange.isValid
}

export const validateCurrentStep = value => {
    return !isNull(value)
}

export const staticData = {
    0: {
        value: "wouldn't change",
        title: locales[window.userLang].life_change_step_1,
        icon: cross,
    },
    1: {
        value: "more confident",
        title: locales[window.userLang].life_change_step_2,
        icon: relivedFace,
    },
    2: {
        value: "much happier",
        title: locales[window.userLang].life_change_step_3,
        icon: laugh,
    },
    3: {
        value: "completely change",
        title: locales[window.userLang].life_change_step_4,
        icon: starsEyes,
    },
}